import Vue from 'vue';
import {
  getReservation, getReservationTypeList, getReservationTimeList, updateReservation, deleteApi, check, success
 } from '../../../services/personnelService/reservationService';
import {
  getMemberDetail, updateMemberNoteName, updateMemberDesc
} from '../../../services/personnelService/memberService';
import { getTags, getMemberTags, storeTags } from '../../../services/backendService/tagsService';

 // initial state
 // state 必為模組區域變數，取時需 store.state.auth.user
 // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
 // 區域使用時值需加上 name
const state = {
  reservations: [],
  pagination: {
    current_page: 0,
    per_page: 5
  },
  reservationsTypeList: [],
  reservationTimeList: [],
  nowSelectStatus: 'checking',
  memberInfo: null,
  tags: [],
  memberTags: []
};

 // getters
 const getters = {};

 // actions
const actions = {
  // 取得預約列表
  async getReservationHandler({ commit }, statusInfo) {
    const data = await getReservation(statusInfo);
    commit('setReservations', data);
  },
  // 傳送簡訊驗證
  async getReservationTypeListHandler({ commit }) {
    const data = await getReservationTypeList();
    commit('setReservationsTypeList', data.data);
  },
  // 拿取可預約時間列表
  async getReservationTimeListHandler({ commit }) {
    const data = await getReservationTimeList();
    commit('setReservationTimeList', data.data);
  },
  // 修改預約
  async updateReservationHandler({}, updateInfo) {
    await updateReservation(updateInfo);
  },
  // 取消確認
  async deleteHandler({}, reservationId) {
    await deleteApi(reservationId);
  },
  // 預約確認
  async checkHandler({}, reservationId) {
    await check(reservationId);
  },
  // 完成確認
  async successHandler({}, reservationId) {
    await success(reservationId);
  },
  // 取得顧客詳細資訊
  async getMemberDetailHandler({ commit }, userId) {
    const data = await getMemberDetail(userId);
    commit('setMemberDetail', data.data);
  },
  // 更新備註名
  async updateMemberNoteNameHandler({}, updateInfo) {
    await updateMemberNoteName(updateInfo);
  },
  // 更新顧客描述
  async updateMemberDescHandler({}, updateInfo) {
    await updateMemberDesc(updateInfo);
  },
  // 取得標籤列表
  async getTagsHandler({ commit }) {
    const data = await getTags();
    commit('setTags', data.data);
  },
  // 取得客戶標籤列表
  async getMemberTagsHandler({ commit }, member_uuid) {
    const data = await getMemberTags(member_uuid);
    commit('setMemberTags', data.data);
  },
  // 儲存標籤
  async storeTagsHandler({}, store_info) {
    await storeTags(store_info);
  }
};

// mutations
const mutations = {
  setReservations(state, data) {
    Vue.set(state, 'reservations', state.reservations.concat(data.data.reservations));
    Vue.set(state, 'pagination', data.pagination);
  },
  setReservationsTypeList(state, data) {
    Vue.set(state, 'reservationsTypeList', data['reservation-list']);
  },
  // 重置所有資料
  resetHandler(state) {
    Vue.set(state, 'reservations', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
  },
  setReservationTimeList(state, data) {
    Vue.set(state, 'reservationTimeList', data['reservation-time']);
  },
  // 切換狀態
  changeSelectStatus(state, data) {
    Vue.set(state, 'nowSelectStatus', data);
  },
  setMemberDetail(state, data) {
    Vue.set(state, 'memberInfo', data.member);
  },
  setTags(state, data) {
    Vue.set(state, 'tags', data);
  },
  setMemberTags(state, data) {
    Vue.set(state, 'memberTags', data);
  }
};

 export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
 };
